// extracted by mini-css-extract-plugin
export default {"container":"RecoverCode_container__bGx5u","inputs":"RecoverCode_inputs__JGxfP","show__password":"RecoverCode_show__password__EpZAs","error":"RecoverCode_error__d-l28"};